import { Component, OnInit } from '@angular/core';
import { Participante } from './participante';
import { ParticipanteService } from './participante.service';
import { Usuario } from './../usuario/usuario';
import { Router } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';

@Component({
  selector: 'app-participantes',
  templateUrl: './participantes.component.html',
  providers: [ParticipanteService, Usuario]
})
export class ParticipantesComponent implements OnInit {

  public busy: Promise<any>;
  public params:any = {nome: undefined, email: undefined, tipo_documento: undefined, numero_documento: undefined};
  public titulo: string = "Participantes";
  public paginaAtual: number = 1;
  public itensPorPagina: number = 1;
  public totalItens: number = 1;

  public participantes: Participante[];
  

  constructor(
    private participanteService: ParticipanteService,
    private _flashMessagesService: FlashMessagesService,
    private router: Router,
    private usuario: Usuario
  ) { }

  pegarTodosParticipantes(): void {
    this.params['page'] = this.paginaAtual;
    this.busy = this.participanteService.pegarTodosParticipantes(this.params)
      .then(participantes => this.carregar(participantes));
  }

  carregar(participantes: any): void{
    this.participantes = participantes.data;
    this.paginaAtual = participantes.current_page;
    this.totalItens = participantes.total;
    this.itensPorPagina = participantes.per_page;
  }

  goEditar(participante_id:number): void{    
    this.router.navigate(['/participante/' + participante_id]);
  }

  pageChanged(page: any): void{
    this.paginaAtual = page;
    this.pegarTodosParticipantes();
  }

  ngOnInit() {
    this.pegarTodosParticipantes();
  }

}



// WEBPACK FOOTER //
// ./src/app/participantes/participantes.component.ts